import { render, staticRenderFns } from "./NewTimes.vue?vue&type=template&id=bcb784b0&scoped=true&"
import script from "./NewTimes.vue?vue&type=script&lang=js&"
export * from "./NewTimes.vue?vue&type=script&lang=js&"
import style0 from "./NewTimes.vue?vue&type=style&index=0&id=bcb784b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb784b0",
  null
  
)

export default component.exports